/*
* forming alphabetically sorted array of finance data by currencies codes and balance:
* firstly by non-zero balance for not crypt cureencies then by non-zero balance for crypt cureencies
* after by zero balance for not crypt cureencies then by zero balance for crypt cureencies
*/

function sortByCurrencies(arr) {
  arr
    .sort((a, b) => {
      if (a.curr_code.toLowerCase() < b.curr_code.toLowerCase()) return -1;
      if (a.curr_code.toLowerCase() > b.curr_code.toLowerCase()) return 1;
      return 0;
    });
  return arr;
}

function sortFinanceDate(financeData) {
  const positiveBalanceCryptArr = [];
  const positiveBalanceNotCryptArr = [];
  const zeroBalanceCryptArr = [];
  const zeroBalanceNotCryptArr = [];

  financeData.forEach((element) => {
    if (+element.amount > 0 && +element.is_crypt) {
      positiveBalanceCryptArr.push(element);
    } else if (+element.amount > 0 && !+element.is_crypt) {
      positiveBalanceNotCryptArr.push(element);
    } else if (+element.amount === 0 && +element.is_crypt) {
      zeroBalanceCryptArr.push(element);
    } else {
      zeroBalanceNotCryptArr.push(element);
    }
  });

  sortByCurrencies(positiveBalanceNotCryptArr);
  sortByCurrencies(positiveBalanceCryptArr);
  sortByCurrencies(zeroBalanceNotCryptArr);
  sortByCurrencies(zeroBalanceCryptArr);

  return positiveBalanceNotCryptArr.concat(positiveBalanceCryptArr, zeroBalanceNotCryptArr, zeroBalanceCryptArr);
}


export default sortFinanceDate;



// WEBPACK FOOTER //
// ./src/shared/utils/helpers/sortFinanceData.js